export default {
  maco: {
    token: null,
    validUntil: null,
    loggedIn: false
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/tomaner/state.js